export function getUniqueDeliveriesFromSequence(sequence) {
  const dos = new Map()

  sequence.forEach((point) => {
    if (!point.activities) return

    point.activities.forEach((activity) => {
      if (!activity.delivery_order) return
      dos.set(activity.delivery_order.id, activity.delivery_order)
    })
  })

  return Array.from(dos.values())
}

export function getValidateQuantityButtonState({
  isSamator,
  fleetTaskStatus,
  fleetTask,
  sequence = [],
  isLoading = false,
}) {
  const hasValidate = fleetTask?.custom_field?.has_validate?.toLowerCase()
  const deliveryPoints = sequence.filter(
    (item) => item.type !== 'START' && item.type !== 'END'
  )
  const firstProductType = deliveryPoints[0]?.activities?.[0]?.delivery_order
    ?.user_definition_fields?.find((field) => field.name?.toLowerCase() === 'product type')
    ?.value?.toLowerCase()
  const allDeliveriesCompleted =
    deliveryPoints.length > 0 &&
    deliveryPoints.every((item) =>
      item.activities?.every((activity) =>
        activity.delivery_order?.user_definition_fields?.find(
          (field) =>
            field.name?.toLowerCase() === 'delivered to epicor' &&
            field.value?.toLowerCase() === 'success'
        )
      )
    )
  const isEligible = isSamator && ['Perjalanan', 'Selesai'].includes(fleetTaskStatus)

  return {
    visible:
      isEligible &&
      (hasValidate === 'true' || hasValidate === 'in progress' ||
        (['tube', 'bulk'].includes(firstProductType) && allDeliveriesCompleted)),
    disabled: ['true', 'in progress'].includes(hasValidate) || isLoading,
  }
}
